import {
  LIST_BADGE_LIFECYCLE_STATE,
  type LifecycleStateFilterDto,
} from '@terra/shared-dto-types';

type SignalTriStateFilter = 'ALL' | 'WITH' | 'WITHOUT';

export type NeedsUnfilteredSignalTotalInput = {
  lifecycleQueryParam: LifecycleStateFilterDto | undefined;
  searchTerm: string;
  urlSearchTerm: string;
  stageFilter: readonly string[];
  statusFilter: readonly string[];
  confidenceFilter: readonly string[];
  categoryFilter: readonly string[];
  originFilter: readonly string[];
  sourceFilter: readonly string[];
  assigneeFilter: readonly string[];
  hasExecutionFilter: SignalTriStateFilter;
  hasFindingFilter: SignalTriStateFilter;
  securityTestFilter: SignalTriStateFilter;
  appWideFilter?: SignalTriStateFilter;
  createdStartDate: Date | null;
  createdEndDate: Date | null;
  testedStartDate: Date | null;
  testedEndDate: Date | null;
};

const hasExtraSignalListFilters = ({
  searchTerm,
  urlSearchTerm,
  stageFilter,
  statusFilter,
  confidenceFilter,
  categoryFilter,
  originFilter,
  sourceFilter,
  assigneeFilter,
  hasExecutionFilter,
  hasFindingFilter,
  securityTestFilter,
  appWideFilter = 'ALL',
  createdStartDate,
  createdEndDate,
  testedStartDate,
  testedEndDate,
}: Omit<NeedsUnfilteredSignalTotalInput, 'lifecycleQueryParam'>): boolean =>
  searchTerm !== '' ||
  urlSearchTerm !== '' ||
  stageFilter.length > 0 ||
  statusFilter.length > 0 ||
  confidenceFilter.length > 0 ||
  categoryFilter.length > 0 ||
  originFilter.length > 0 ||
  sourceFilter.length > 0 ||
  assigneeFilter.length > 0 ||
  hasExecutionFilter !== 'ALL' ||
  hasFindingFilter !== 'ALL' ||
  securityTestFilter !== 'ALL' ||
  appWideFilter !== 'ALL' ||
  createdStartDate !== null ||
  createdEndDate !== null ||
  testedStartDate !== null ||
  testedEndDate !== null;

export const needsUnfilteredSignalTotal = ({
  lifecycleQueryParam,
  ...extraFilters
}: NeedsUnfilteredSignalTotalInput): boolean =>
  hasExtraSignalListFilters(extraFilters) ||
  lifecycleQueryParam !== LIST_BADGE_LIFECYCLE_STATE;
